import React from 'react'
import { WifiIcon } from '@heroicons/react/24/outline'

const OfflineIndicator: React.FC = () => {
  return (
    <div className="bg-red-100 dark:bg-red-900 border-b border-red-200 dark:border-red-700 px-6 py-2">
      <div className="flex items-center">
        <WifiIcon className="h-4 w-4 text-red-600 dark:text-red-400 mr-2" />
        <span className="text-sm text-red-800 dark:text-red-200">
          You're currently offline. Changes will be synced when connection is restored.
        </span>
      </div>
    </div>
  )
}

export default OfflineIndicator

